export class User {
    constructor(userID, userEmail, userFName, userRolePrimary = 'guest', userLName = null, userCreationDate = null, userDOB = null, userAddress = null, userCity = null, userState = null, userZip = null, renterID = null, userPhoneNumber = null, themePreference = 'system', userPhotoURL = null) {
      // Required fields
      this.userID = userID;
      this.userEmail = userEmail;
      this.userFName = userFName;
      this.userRolePrimary = userRolePrimary
      // Optional fields with default values
      this.userLName = userLName;
      this.userCreationDate = userCreationDate;
      this.userDOB = userDOB;
      this.userAddress = userAddress;
      this.userCity = userCity;
      this.userState = userState;
      this.userZip = userZip;
      this.renterID = renterID;
      this.userPhoneNumber = userPhoneNumber;
      this.themePreference = themePreference;
      this.userPhotoURL = userPhotoURL;
    }
  
    // Getter methods
    getUserID() { return this.userID; }
    getUserEmail() { return this.userEmail; }
    getUserFName() { return this.userFName; }
    getUserLName() { return this.userLName; }
    getUserRolePrimary() { return this.userRolePrimary; }
    getUserCreationDate() { return this.userCreationDate; }
    getUserDOB() { return this.userDOB; }
    getUserAddress() { return this.userAddress; }
    getUserCity() { return this.userCity; }
    getUserState() { return this.userState; }
    getUserZip() { return this.userZip; }
    getUserRenterID() { return this.renterID; }
    getUserOperatorID() { return this.userID; } // For operators, the operator ID is the same as the user ID
    getUserPhoneNumber() { return this.userPhoneNumber; }
    hasPhoneNumber() { return !!this.userPhoneNumber; }
    getThemePreference() { return this.themePreference; }
    getUserPhotoURL() { return this.userPhotoURL; }

    // Setter methods for optional fields
    setUserDOB(dob) { this.userDOB = dob; }
    setUserAddress(address) { this.userAddress = address; }
    setUserCity(city) { this.userCity = city; }
    setUserState(state) { this.userState = state; }
    setUserZip(zip) { this.userZip = zip; }
    setUserPhoneNumber(phoneNumber) { this.userPhoneNumber = phoneNumber; }
  
    // You might want to add setter methods for required fields if you need to update them later
  
    // Optional: A method to get a simple representation of the user
    getBasicInfo() {
      return {
        id: this.userID,
        name: `${this.userFName} ${this.userLName}`,
        email: this.userEmail,
        role: this.userRolePrimary
      };
    }
  
    // Optional: A method to check if all optional fields are filled
    isProfileComplete() {
      return this.userDOB !== null &&
             this.userAddress !== null &&
             this.userCity !== null &&
             this.userState !== null &&
             this.userZip !== null;
    }
  }